import { NativeShareImage, NativeShareString, NativeShareVideo } from "./types";

const TITLE = "swsh";
export const nativeShareString: NativeShareString = async (content) => {
	if (!content) return { didShare: false };
	const body = {
		title: TITLE,
		text: content,
	};
	if (!navigator.canShare(body)) {
		throw new Error("Cannot native share");
	}
	const didShare = await navigator
		.share({
			text: content,
			title: TITLE,
		})
		.then(() => true)
		.catch((err) => {
			if (err.name === "AbortError") return false;
			throw err;
		});
	return { didShare };
};

export const nativeShareImage: NativeShareImage = async (results) => {
	if (results.length === 0) return { didShare: false };
	const files = await Promise.all(
		results.map(async (data, index) => {
			return new File([await data.blob()], `swsh-${index}.${await data.ext()}`, {
				type: await data.contentType(),
			});
		}, []),
	);

	const body = {
		title: TITLE,
		files: files,
	};

	if (!navigator.canShare(body)) {
		throw new Error("Cannot native share");
	}
	const didShare = await navigator
		.share(body)
		.then(() => true)
		.catch((err) => {
			if (err.name === "AbortError") return false;
			throw err;
		});
	return { didShare };
};

export const nativeShareVideo: NativeShareVideo = async () => {
	return { didShare: false };
};
